export const CourseHome = {
    "考勤":"考勤",
    "表现":"表现",
    "成绩管理":"成绩管理",
    "学情分析":"学情分析",
    "报名审核":"报名审核",
    "成绩":"成绩",
    "学习分析":"学习分析",
    "错题集":"错题集",
    "课堂正在上课":"课堂正在上课/直播...",
    "立即进入":"立即进入",
    "正在会议中":"正在会议中...",
    "个会议正在进行中":"个会议正在进行中…",
    "会议功能需要绑定邮箱后才能使用!":"会议功能需要绑定邮箱后才能使用!",
    "学习资料":"学习资料",
    "慕课资料":"慕课资料",
    "录屏录像":"录屏录像",
    "直播录像":"直播录像",
    "课程内容":"课程内容",
    "加课码已停用":"加课码已停用",
    "加课码已启用":"加课码已启用",
    "学生视角":"学生视角",
    "课堂评价":"课堂评价",
    "分组":"分组",
    "加课码":"加课码",
    "已认证":"已认证",
    "成员":"成员",
    "已加课":"已加课",
    "课程介绍":"课程介绍",
    "个章节":"个章节",
    "个活动":"个活动",
    "该小节暂无内容":"该小节暂无内容",
    "该课程暂无章节":"该课程暂无章节",
    "正同步数据":"正同步数据",
    "检测到旧版课程数据向新版同步未完成":"检测到旧版课程数据向新版同步未完成",
    "当前同步进度":"当前同步进度",
    "学习进度":"学习进度",
    "继续学习":"继续学习",
    "当前进入学生视角":"当前进入学生视角，以学生身份体验课程",
    "进行中":"进行中...",
    "最新":"最新",
    "目录":"目录",
    "待完成":"待完成",
    "学时":"学时",
    "请完善以下信息":" 请完善以下信息",
    "班级":"班级",
    "请输入班级":"请输入班级",
    "年级":"年级",
    "请选择年级":"请选择年级",
    "入学时间":"入学时间",
    "请选择入学时间":"请选择入学时间",
    "引用":"引用",
    "课堂已结束请对本次课堂进行评价":"课堂已结束！请对本次课堂进行评价（匿名）",
    "匿名提交评价":"匿名提交评价",
    "评价成功":"评价成功！",
    "被引用":"被引用",
    "次":"次",
    "已下载":"已下载",
    "引用到课程":"引用到课程",
    "慕课外链":"慕课外链",
    "邀请您进入课程":"邀请您进入课程",
    "输入加课码直达":"输入加课码直达",
    "评审":"评审",
    "截止":"截止:",
    "起止":"起止:",
    "试题":"试题:",
    "直播视频":"直播视频",
    "录播视频":"录播视频",
    "互动视频":"互动视频",
    "待学习":"待学习",
    "待参与":"待参与",
    "未提交":"未提交",
    "已提交":"已提交",
    "已批改":"已批改",
    "待批改":"待批改",
    "进入会议":"进入会议",
    "待开始":"待开始",
    "发布会议":"发布会议",
    "将于开始":"将于",
    "空开始":"开始",
    "未批":"未批",
    "已学完":"已学完",
    "创建时间":"创建时间:",
    "抢答":"抢答",
    "抢答成功":"抢答成功",
    "已有":"已有",
    "学年学期":"学年-学期",
    "授课地点":"授课地点",
    "授课模式":"授课模式",
    "全年":"全年",
    "上学期":"上学期",
    "下学期":"下学期",
    "请确认是否删除此":"请确认是否删除此",
   "当前显示的教学活动模块":"当前显示的教学活动模块",
   "原":"（原",
   "更多模块":"更多模块",
   "点击即可添加模块":"点击即可添加模块",
   "修改教学活动模块名":"修改教学活动模块名",
   "结构化组织教学活动":"结构化组织教学活动",
   "上课课件":"上课课件",
   "老师分享资料":"老师分享资料",
   "投票问卷答题":"投票、问卷、答题",
   "报告或文档型作业":"报告或文档型作业",
   "提供师生讨论功能":"提供师生讨论功能",
   "阶段性测试考核":"阶段性测试、考核",
   "通知公告等":"通知、公告等",
   "链接腾讯会议":"链接腾讯会议",
   "教学活动模块名称不能为空":"教学活动模块名称不能为空",
   "教学活动模块名称最多 8 个字":"教学活动模块名称最多 8 个字",
   "至少存在一个教学活动模块":"至少存在一个教学活动模块",
   "当前暂无可学习内容":"当前暂无可学习内容",
   "老师已经禁止学生发起话题":"老师已经禁止学生发起话题",
   "您有未完成的评教":"您有未完成的评教",
   "是否填写评教":"是否填写评教",
   "去填写":"去填写",
   "暂不填写":"暂不填写",
   "开始评教":"开始评教",
   "题未作答请检查后提交":"题 未作答，请检查后提交",
   "评教提交成功":"评教提交成功",
   "今日":"今日",
   "学生评价参与率":"学生评价参与率",
   "好评率":"好评率",
   "待改进":"待改进",
   "得分占比":"得分占比",
   "问题评价占比":"问题评价占比",
   "自定义日期":"自定义日期",
   "请输入":"请输入",
   "提交成功等待审核":"提交成功，等待审核",
   "耐心等待老师审核如有疑问请与课程老师联络":"耐心等待老师审核，如有疑问，请与课程老师联络",
   "有必填项未填":"有必填项未填",
   "未认证":"未认证",
   "重命名标签":"重命名标签",
   "全选":"全选",
   "移出小组":"移出小组",
   "加入小组":"加入小组",
   "设为组长":"设为组长",
   "设为组长跳转":"设为组长跳转",
   "组数":"组数",
   "允许学生选组":"允许学生选组",
   "禁止":"禁止",
   "允许":"允许",
   "学生进组":"学生进组",
   "未分组学生":"未分组学生",
   "我加入的小组":"我加入的小组",
   "人数":"人数",
   "其他组":"其他组",
   "本分组内暂无小组":"本分组内暂无小组",
   "你可以":"你可以",
   "建立第一个小组":"建立第一个小组",
   "新建小组":"新建小组",
   "分组设置":"分组设置",
   "已删除":"已删除",
   "设置成功":"设置成功",
   "设定组长":"设定组长",
   "设定组长成功":"设定组长成功",
   "分组标题":"分组标题",
   "请输入分组标题":"请输入分组标题",
   "小组人数上限":"小组人数上限",
   "允许学生新建删除小组":"允许学生新建/删除小组",
   "组数上限":"组数上限",
   "移除成功":"移除成功",
   "加入成功":"加入成功",
   "选择加入的小组":"选择加入的小组",
   "添加成员":"添加成员",
   "加入该组":"加入该组",
   "退出该组":"退出该组",
   "移除组员":"移除组员",
   "编辑小组":"编辑小组",
   "删除小组":"删除小组",
   "确定要删除小组":"确定要删除小组",
   "已退出":"已退出",
   "已加入":"已加入",
   "移出成功":"移出成功",
   "添加组员":"添加组员",
   "暂无分组":"暂无分组",
   "固定组":"固定组",
   "自由组":"自由组",
   "限制组":"限制组",
   "已进组人数":"已进组人数",
   "未进组人数":"未进组人数",
   "新建分组":"新建分组",
   "小组名称":"小组名称",
   "请输入小组名称":"请输入小组名称",
   "加入时间":"加入时间",
   "学生信息":"学生信息",
   "助教信息":"助教信息",
   "老师信息":"老师信息",
   "学生分组":"学生分组",
   "设置":"设置",
   "不允许退课":"不允许退课",
   "成员设置":"成员设置",
   "总览":"总览",
   "松开发送":"松开发送",
   "按住讲话":"按住讲话",
   "松开发送上滑取消":"松开 发送，上滑 取消",
   "取消发送语音":"取消发送语音",
   "老师已禁止发言":"老师已禁止发言!",
   "条":"条",
   "按时间":"按时间",
   "课堂对象全部成员":"课堂对象：全部成员",
   "上课人数":"上课人数",
   "上课时长":"上课时长",
   "提问":"提问",
   "口头回答":"口头回答",
   "手机抢答":"手机抢答",
   "查看详情":"查看详情",
   "关闭弹幕":"关闭弹幕",
   "弹幕数":"弹幕数",
   "日":"日",
   "暂无课堂记录":"暂无课堂记录",
   "话题参与率":"话题参与率",
   "互动参与率":"互动参与率",
   "出勤率":"出勤率",
   "表现星星数":"表现星星数",
   "作业提交率":"作业提交率",
   "班级平均":"班级平均",
   "学生个人":"学生个人",
   "发布数":"发布数",
   "回答数":"回答数",
   "学习人数":"学习人数",
   "标签":"标签",
   "固定小组":"固定小组",
   "活动分组":"活动分组",
   "整体完成率":"整体完成率",
   "作业提交":"作业提交",
   "资料学习":"资料学习",
   "测试提交":"测试提交",
   "本周":"本周",
   "本月":"本月",
   "课堂互动次数":"课堂互动次数",
   "作业发布次数":"作业发布次数",
   "测试发布次数":"测试发布次数",
   "话题回复数":"话题回复数",
   "互动课件发布次数":"互动课件发布次数",
   "资料发布次数":"资料发布次数",
   "资料互动课件发布次数":"资料/互动课件发布次数",
   "弹幕条数":"弹幕条数",
   "课堂互动":"课堂互动",
   "累计发布抢答条数":"累计发布抢答条数",
   "参与抢答人数":"参与抢答人数",
   "抢答平均参与率":"抢答平均参与率",
   "累计发布提问次数":"累计发布提问次数",
   "累计随机提问次数":"累计随机提问次数",
   "累计点名提问次数":"累计点名提问次数",
   "累计发布个数":"累计发布个数",
   "答题总数":"答题总数",
   "平均参与率":"平均参与率",
   "平均正确率":"平均正确率",
   "互动答题榜":"互动答题榜",
   "正确率":"正确率",
   "参与率":"参与率",
   "抢答榜":"抢答榜",
   "成功次数":"成功次数",
   "表现榜":"表现榜",
   "累计星星数":"累计星星数",
   "累计发布次数":"累计发布次数",
   "提交作业份数":"提交作业份数",
   "作业平均分":"作业平均分",
   "作业提交人数":"作业提交人数",
   "准时提交率":"准时提交率",
   "测试平均分":"测试平均分",
   "累计参与测试人数":"累计参与测试人数",
   "测试提交率":"测试提交率",
   "累计话题发布数":"累计话题发布数",
   "累计话题回复数":"累计话题回复数",
   "累计点赞数":"累计点赞数",
   "话题精华率":"话题精华率",
   "成员参与率":"成员参与率",
   "资料类型":"资料类型",
   "资料互动课件":"资料/互动课件",
   "平均学习进度":"平均学习进度",
   "整体分析":"整体分析",
   "学生分析":"学生分析",
   "开始上课":"开始上课",
   "下课":"下课",
   "创建人":"创建人",
   "提交":"提交",
}
